import { render, staticRenderFns } from "./change_status.vue?vue&type=template&id=2fa0c6e2&scoped=true&"
import script from "./change_status.vue?vue&type=script&lang=js&"
export * from "./change_status.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa0c6e2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2fa0c6e2')) {
      api.createRecord('2fa0c6e2', component.options)
    } else {
      api.reload('2fa0c6e2', component.options)
    }
    module.hot.accept("./change_status.vue?vue&type=template&id=2fa0c6e2&scoped=true&", function () {
      api.rerender('2fa0c6e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/platforms/invoices/actions/change_status.vue"
export default component.exports